// Дашборд — корневой адрес панели. Остальные разделы открываются как /{code}.
export function sectionPath(code) {
  if (!code || code === 'dashboard') return '/';
  return `/${encodeURIComponent(code)}`;
}

export function sectionFromPath(pathname) {
  const segment = String(pathname || '')
    .split('?')[0]
    .split('#')[0]
    .replace(/^\/+|\/+$/g, '')
    .split('/')[0];
  if (!segment) return '';
  try {
    return decodeURIComponent(segment);
  } catch {
    return segment;
  }
}

export function userCardPath(sectionCode, userId) {
  return `${sectionPath(sectionCode)}/${encodeURIComponent(userId)}`;
}

export function userIdFromPath(pathname, sectionCode) {
  const parts = String(pathname || '')
    .split('?')[0]
    .split('#')[0]
    .replace(/^\/+|\/+$/g, '')
    .split('/')
    .filter(Boolean);
  if (parts.length !== 2 || !sectionCode) return '';
  let section = parts[0];
  let userId = parts[1];
  try {
    section = decodeURIComponent(section);
    userId = decodeURIComponent(userId);
  } catch {
    return '';
  }
  if (section !== sectionCode || !userId) return '';
  return userId;
}

export function sectionToOpen(items, requested, fallbackCode) {
  const list = items || [];
  const codes = new Set(list.map((item) => item.code));
  if (requested && codes.has(requested)) return requested;
  if (!requested && fallbackCode && codes.has(fallbackCode)) return fallbackCode;
  if (codes.has('dashboard')) return 'dashboard';
  return list[0] ? list[0].code : '';
}
